import { render, staticRenderFns } from "./RegistroCompleto.vue?vue&type=template&id=92bab8cc"
import script from "./RegistroCompleto.vue?vue&type=script&lang=js"
export * from "./RegistroCompleto.vue?vue&type=script&lang=js"
import style0 from "./RegistroCompleto.vue?vue&type=style&index=0&id=92bab8cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports